export default __webpack_public_path__ + "static/footer-logo-new-4-d7f4ac3329fff05500c3ba273877e244.svg";